import { CreditCard } from 'lucide-react';

export const PaymentAllocationPicker = ({ payments, allocations, onChange, documentBalance, label }) => {
  const selectedTotal = Object.values(allocations).reduce((sum, amount) => sum + (parseFloat(amount) || 0), 0);

  const togglePayment = (payment) => {
    if (allocations[payment.id] !== undefined) {
      const next = { ...allocations };
      delete next[payment.id];
      onChange(next);
      return;
    }
    const remainingDocumentBalance = Math.max(0, documentBalance - selectedTotal);
    onChange({
      ...allocations,
      [payment.id]: Math.min(payment.unallocated_amount || 0, remainingDocumentBalance),
    });
  };

  if (!payments.length) return null;

  return (
    <div className="border border-blue-200 bg-blue-50/40 rounded-sm p-4">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <CreditCard className="h-4 w-4 text-blue-600" />
          <span className="text-sm font-semibold text-slate-700">Apply Available {label}</span>
        </div>
        <span className="text-xs font-medium text-blue-700">Selected: ₹{selectedTotal.toLocaleString('en-IN')}</span>
      </div>
      <div className="space-y-2 max-h-48 overflow-y-auto">
        {payments.map(payment => {
          const selected = allocations[payment.id] !== undefined;
          return (
            <div key={payment.id} className="grid grid-cols-[auto_1fr_120px] gap-3 items-center bg-white border border-slate-200 px-3 py-2">
              <input type="checkbox" checked={selected} onChange={() => togglePayment(payment)}
                data-testid={`allocate-payment-${payment.id}`} className="h-4 w-4 text-orange-500 border-slate-300 rounded" />
              <div className="min-w-0">
                <div className="text-sm font-medium text-slate-800 truncate">
                  {payment.receipt_number || payment.reference_number || payment.payment_type || 'Payment'}
                </div>
                <div className="text-xs text-slate-500">
                  {payment.date || 'No date'} · Available ₹{(payment.unallocated_amount || 0).toLocaleString('en-IN')}
                </div>
              </div>
              <input type="number" min="0" step="0.01"
                max={Math.min(payment.unallocated_amount || 0, documentBalance)}
                disabled={!selected}
                value={selected ? allocations[payment.id] : ''}
                onChange={event => onChange({ ...allocations, [payment.id]: event.target.value })}
                aria-label={`Allocation amount for ${payment.receipt_number || payment.reference_number || payment.id}`}
                className="w-full px-2 py-1.5 border border-slate-200 rounded-sm text-sm text-right disabled:bg-slate-100" />
            </div>
          );
        })}
      </div>
    </div>
  );
};
